







import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class ErrorSummary extends Vue {
  @Prop({ default: [] })
  private error_summary!: string[];
}
